<template>
  <section class="section values-section reveal-section" id="valores" ref="sectionRef">
    <div class="section-header">
      <span class="section-label">Lo que nos define</span>
      <h2 class="section-title">Nuestros Valores</h2>
      <p class="section-subtitle">Los principios que guían todo lo que hacemos</p>
    </div>
    <div class="values-grid">
      <div v-for="(value, index) in values" :key="index" class="value-item">
        <i :class="value.icon"></i>
        <h4>{{ value.title }}</h4>
        <p>{{ value.description }}</p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useScrollReveal } from '@/composables/useAnimations'

const sectionRef = ref<HTMLElement | null>(null)
const { registerReveal } = useScrollReveal()
onMounted(() => registerReveal(sectionRef.value))

const values = ref([
  { title: 'Amor', description: 'Cada acción nace del amor genuino por Dios y por las personas.', icon: 'fas fa-heart' },
  { title: 'Integridad', description: 'Vivimos con transparencia y coherencia en todo lo que hacemos.', icon: 'fas fa-shield-alt' },
  { title: 'Visión', description: 'Miramos más allá de lo presente, creyendo en lo que Dios puede hacer.', icon: 'fas fa-lightbulb' },
  { title: 'Servicio', description: 'Servir es nuestra mayor expresión de liderazgo y amor.', icon: 'fas fa-hands-helping' }
])
</script>

<style scoped>
.values-section { background: var(--vh-gris-piedra); }
.values-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 2rem; max-width: 1000px; margin: 0 auto; }
.value-item {
  text-align: center; padding: 2rem;
  transition: var(--vh-transicion); border-radius: 20px;
}
.value-item:hover { background: white; box-shadow: 0 10px 30px var(--vh-sombra); transform: translateY(-5px); }
.value-item i { font-size: 2.5rem; color: var(--vh-azul-profundo); margin-bottom: 1rem; transition: var(--vh-transicion); }
.value-item:hover i { color: var(--vh-dorado); transform: scale(1.2); }
.value-item h4 { font-size: 1.2rem; color: var(--vh-azul-profundo); margin-bottom: 0.5rem; }
.value-item p { color: #555; font-size: 0.95rem; line-height: 1.6; }
</style>
